import { skipToken } from "@reduxjs/toolkit/query/react"
import {
  EmbeddedCheckout,
  EmbeddedCheckoutProvider,
} from "@stripe/react-stripe-js"
import { JugglingScreen, useTheme } from "@motleyhand/design"
import CheckoutSuccess from "./CheckoutSuccess"
import stripe from "./stripe"
import {
  useCreateCheckoutSessionQuery,
  useGetCheckoutSessionQuery,
} from "./api"
import type { Cart } from "./model"
import { invariant } from "@/utils"

type Props = {
  cart: Cart
  sessionId?: string
}

export default function CheckoutPage({ cart, sessionId }: Props) {
  const { data: session, isLoading: isSessionLoading } =
    useGetCheckoutSessionQuery(sessionId ?? skipToken)
  const { colorScheme: colourScheme } = useTheme()
  const { data: checkout, isLoading: isCheckoutLoading } =
    useCreateCheckoutSessionQuery(
      !sessionId || (!isSessionLoading && !session?.success)
        ? { cart, colourScheme }
        : skipToken,
    )

  if ((sessionId && isSessionLoading) || isCheckoutLoading) {
    return <JugglingScreen />
  }

  if (sessionId && session?.success) {
    return <CheckoutSuccess cart={cart} />
  }

  invariant(checkout)

  return (
    <div className="pb-4">
      <EmbeddedCheckoutProvider stripe={stripe} options={checkout}>
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  )
}
